module.exports = __webpack_public_path__ + "img/fanke.a4bb5195.png";